<template>
	<b-container fluid>
		<b-row>
			<b-col lg>
				<b-row>
					<b-col>
						<h5>Update Email</h5>
					</b-col>
				</b-row>
				<hr/>
				<b-row>
					<b-col>
						<strong>Current Email</strong>
						<b-form-input v-if="status === 'fetched'" v-model="email" type='email' disabled></b-form-input>
						<b-form-input v-else-if="status === 'loading'" class="text-center" value="..." disabled></b-form-input>
						<b-form-input
							v-else-if="status === 'error'"
							value="Error fetching current email. Try refreshing the page."
							class="text-center"
							disabled
						></b-form-input>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<strong>New Email</strong>
						<b-form-input v-model="newEmail" type='email'></b-form-input>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<strong>Confirm New Email</strong>
						<b-form-input v-model="confirmEmail" type='email' autocomplete="off"></b-form-input>
					</b-col>
				</b-row>
				<b-row class='my-2'>
					<b-col>
						<b-button
							variant="primary"
							@click="updateEmail()"
						>
							Update Email
						</b-button>
					</b-col>
				</b-row>
			</b-col>

			<b-col lg>
				<b-row>
					<b-col>
						<h5>Update Password</h5>
					</b-col>
				</b-row>
				<hr/>
				<b-row>
					<b-col>
						<strong>Current Password</strong>
						<b-form-input
							v-model="currentPassword"
							type="password"
						></b-form-input>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<strong>New Password</strong>
						<b-form-input
							v-model="newPassword"
							type="password"
						></b-form-input>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<strong>Confirm New Password</strong>
						<b-form-input
							v-model="confirmPassword"
							type="password"
							autocomplete="off"
						></b-form-input>
					</b-col>
				</b-row>
				<b-row class='my-2'>
					<b-col>
						<b-button
							variant="primary"
							@click="updatePassword()"
						>
							Update Password
						</b-button>
					</b-col>
				</b-row>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
// @ is an alias to /src
const sha512 = require("js-sha512")

export default {
	name: "Account",
	data() {
		return {
			status: "loading",
			email: "",
			newEmail: "",
			confirmEmail: "",
			currentPassword: "",
			newPassword: "",
			confirmPassword: ""
		}
	},
	methods: {
		checkLogin: function() {
			return new Promise((resolve, reject) => {
				if (this.$cookies.get("token")) {
					fetch(this.$apiURL + "/checkLogin", {
						method: "GET",
						headers: new Headers({
							Authorization: this.$cookies.get("token"),
							"Content-Type": "application/json",
						}),
					}).then(res => {
						if (res.ok) {
							// user is logged in
							res.json().then(user => {
								this.$store.state.user.userID = user.userID
								this.$store.state.user.admin = user.admin
								resolve()
							})
						} else {
							this.$cookies.remove("token")
							this.$cookies.remove("userID")
							this.$cookies.remove("admin")
							window.location.replace("/login.html")
							reject()
						}
					})
				} else {
					this.$cookies.remove("token")
					this.$cookies.remove("userID")
					this.$cookies.remove("admin")
					this.$router.push("/Login")
					reject()
				}
			})
		},
		getEmail: function() {
			return new Promise((resolve, reject) => {
				fetch(this.$apiURL + "/getEmail", {
					method: "GET",
					headers: new Headers({
						Authorization: this.$store.state.token,
						"Content-Type": "application/json",
					}),
				}).then(res => {
					console.log(res)
					if (res.ok) {
						res.json().then(data => {
							this.email = data.email
							this.status = "fetched"
							resolve()
						})
					} else {
						this.status = "error"
						reject()
					}
				})
			})
		},
		updateEmail: function () {
			if (this.newEmail != this.confirmEmail) {
				alert('Both new email inputs must match.')
			}
			else if (!this.newEmail.includes('@')) {
				alert('Email not valid')
			}
			else {
				return new Promise((resolve, reject) => {
					fetch(this.$apiURL + "/updateEmail", {
						method: "POST",
						headers: new Headers({
							Authorization: this.$store.state.token,
							"Content-Type": "application/json",
						}),
						body: JSON.stringify({
							newEmail: this.newEmail,
						}),
					}).then(res => {
						console.log(res)
						if (res.ok) {
							this.email = this.newEmail
							this.newEmail = ''
							this.confirmEmail = ''
							alert('Email successfully updated.')
							resolve()
						} else {
							alert('Error updating email. Try again.')
							reject()
						}
					})
				})
			}
		},
		updatePassword: function () {
			if (this.newPassword != this.confirmPassword) {
				alert('Both new email inputs must match.')
			}
			else {
				return new Promise((resolve, reject) => {
					fetch(this.$apiURL + "/updatePassword", {
						method: "POST",
						headers: new Headers({
							Authorization: this.$store.state.token,
							"Content-Type": "application/json",
						}),
						body: JSON.stringify({
							oldPassword: sha512(this.currentPassword),
							newPassword: sha512(this.newPassword),
						}),
					}).then(res => {
						if (res.ok) {
							this.newPassword = ''
							this.confirmPassword = ''
							alert('Password successfully updated.')
							resolve()
						} else if (res.status === 400) {
							alert('Current password is incorrect. Try again.')
							reject()
						}
						else {
							alert('Error updating password. Try again.')
							reject()
						}
					})
				})
			}
		}
	},
	created() {
		this.checkLogin().then(async () => {
			await this.getEmail()
		})
	},
}
</script>

<style scoped>
h5 {
	text-align: center;
}

strong {
	text-align: center;
	display: block;
}

input {
	max-width: 350px;
	margin: 10px auto;
	text-align: center;
}

button {
	display: block;
	margin: 0 auto;
}
</style>